<template>
  <div>
    <v-btn @click="downloadExcel('listing')">Download Excel Listing</v-btn>
    <v-btn @click="downloadPDF">Download PDF Listing</v-btn>
    <v-btn @click="openModal('add')" class="ml-5">Add User</v-btn>

     <e-update-stats-modal
      :isOn="hasDialogs.delete"
      actionName="delete"
      :changableId="changableId"
      @getDataFromApi="getDataFromApi()"
      @closeModal="closeModal('delete')"
      :disabled="buttonDisabled"
    />
    <e-update-stats-modal
      :isOn="hasDialogs.approve"
      actionName="approve"
      :changableId="changableId"
      @getDataFromApi="getDataFromApi()"
      @closeModal="closeModal('approve')"
      :disabled="buttonDisabled"
    />
    <e-update-stats-modal
      :isOn="hasDialogs.remind"
      actionName="remind"
      :changableId="changableId"
      @closeModal="closeModal('remind')"
      @getDataFromApi="getDataFromApi()"
      :disabled="buttonDisabled"
    />

    <v-card-title>
      <v-flex xs1 class="mx-4">
        <v-select
          :items="statusOfCompany.statuses"
          v-model="activeStatus"
          label="Status Filter"
        ></v-select>
      </v-flex>
      <v-flex xs1>
        <v-btn color="primary" @click.stop="reset">Reset</v-btn>
      </v-flex>
      <v-flex xs3 class="my-3 ml-5">
        <v-layout>
          Not Yet: {{getCounterListing.notYet}}
          <v-spacer/>
          Pending: {{getCounterListing.pending}}
          <v-spacer/>
          Approved: {{getCounterListing.approved}}
          <v-spacer/>
          Deleted: {{getCounterListing.deleted}}
        </v-layout>
      </v-flex>
      <v-flex xs-3 offset-xs2>
        <v-layout>
          <v-text-field
            class="mr-4"
            append-icon="search"
            label="Search for receiver company"
            single-line
            hide-details
            v-model="searchValueCompany"
          />
          <v-text-field
            class="mr-4"
            append-icon="search"
            label="Search for name"
            single-line
            hide-details
            v-model="searchValueName"
          />
          <v-text-field
            class="ml-4"
            append-icon="search"
            label="Search for receiver email"
            single-line
            hide-details
            v-model="searchValueEmail"
          />
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table
      v-if="isLoadTable"
      :headers="headers"
      :items="listings"
      class="elevation-1"
      :pagination.sync="pagination"
      :total-items="getTotalItemsListings"
      :loading="isLoading"
      :disable-initial-sort="true"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs">{{ props.item.listingInvitation.name }}</td>
          <td class="text-xs">
            {{ props.item.listingInvitation.company }}
          </td>
          <td class="text-xs">{{
              checkWayOfMetadata(props.item, 'listingInvitation', 'company') ||
              checkWayOfListingInvitation( props.item, 'company')
            }}
          </td>
          <td class="text-xs">
            {{ props.item.listingInvitation.email }}
          </td>
          <td class="text-xs">
            <p class="my-2">
              <strong>Email: </strong>{{
                checkWayOfMetadata(props.item, 'listingInvitation', 'email') ||
                checkWayOfListingInvitation( props.item, 'email')
              }}
            </p>
            <p class="my-2">
              <strong>Company Email: </strong>
              {{ checkWayOfMetadata(props.item, 'listingMetadata','companyEmailAddress') }}
            </p>
          </td>
          <td class="text-xs">{{checkWayOfListingInvitation(props.item, 'status')}}
          </td>
          <td class="text-xs">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="openDataUpdate(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>restore</v-icon>
              </v-btn>
              <span>Update data</span>
            </v-tooltip>
          </td>
          <td class="text-xs">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="openTokenModel(checkWayOfListingInvitation(props.item, 'invitationToken'))"
                :disabled="!isWriteAvailable"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
              <span>Show Token</span>
            </v-tooltip>
          </td>
          <td class="text-xs">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="showPDF(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>insert_drive_file</v-icon>
              </v-btn>
              <span>Pre default PDF, only for Pending or Approved</span>
            </v-tooltip>
          </td>
          <td>
            <v-layout row>
              <v-flex xs2>
                <v-tooltip
                  v-if="contains(checkWayOfListingInvitation( props.item, 'status'), statusOfCompany.resendBtn)"
                  bottom
                >
                  <v-btn
                    fab flat
                    color="info"
                    slot="activator"
                    @click="openQuestionModal('remind', props.item.id)"
                    :disabled="!isWriteAvailable"
                  >
                    <v-icon>email</v-icon>
                  </v-btn>
                  <span>Remind invitation link</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs2>
                <v-tooltip
                  v-if="contains(checkWayOfListingInvitation( props.item, 'status'), statusOfCompany.approveBtn)"
                  bottom
                >
                  <v-btn
                    color="success"

                    fab flat
                    slot="activator"
                    @click="openQuestionModal('approve', props.item.id)"
                  >
                    <v-icon>done</v-icon>
                  </v-btn>
                  <span>Approve</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs2>
                <v-tooltip
                  v-if="contains(checkWayOfListingInvitation( props.item, 'status'), statusOfCompany.deleteBtn)"
                  bottom
                >
                  <v-btn
                    color="error"
                    :disabled="!isWriteAvailable"
                    fab flat
                    slot="activator"
                    @click="openQuestionModal('delete', props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs2>
                <v-tooltip
                  v-if="contains(checkWayOfListingInvitation( props.item, 'status'), statusOfCompany.editBtn)"
                  bottom
                >
                  <v-btn
                    color="lime"
                    :disabled="!isWriteAvailable"
                    fab flat
                    slot="activator"
                    @click="openModal('edit', props.item)"
                  >
                    <v-icon>create</v-icon>
                  </v-btn>
                  <span>Edit</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs2>
                <v-tooltip
                  v-if="contains(checkWayOfListingInvitation( props.item, 'status'), statusOfCompany.editBtn)"
                  bottom
                >
                  <v-btn
                    color="orange accent-4"
                    fab flat
                    slot="activator"
                    @click="showResetStatusModal(props.item.id)"
                  >
                    <v-icon>undo</v-icon>
                  </v-btn>
                  <span>Reset status</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>

    <modal-company-info
      v-if="hasDialogs.openModel"
      :id="modalId"
      :isShow="hasDialogs.openModel"
      @close="closeModal('openModel')"
      @done="doneSaveListing"
      :listingStatusProp="listingStatus"
      :listingInvitationProp="listingInvitation"
      :listingMetadataProp="listingMetadata"
      :additionalInformationProp="additionalInformation"
      :getFormData="getFormData"
    />

    <data-update
      v-if="hasDialogs.dataUpdate"
      :isShow="hasDialogs.dataUpdate"
      :data="dataUpdate"
      @close="closeModal('dataUpdate')"
    />

    <show-token-model
      v-if="hasDialogs.showToken"
      :isShow="hasDialogs.showToken"
      :token="token"
      @close="closeModal('showToken')"
    />

    <predefined-image-model
      v-if="hasDialogs.PDFimage"
      :isShow="hasDialogs.PDFimage"
      :imgSrc="PDFimage"
      @close="closeModal('PDFimage')"
    />

    <v-dialog persistent v-model="isResetStatusModalVisible" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>Reset status to "NotYet":</h3>
        </v-card-title>
        <v-card-text>
          Are you sure that you want to reset current status?
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn color="success" @click="resetStatus()">Reset status</v-btn>
          <v-btn color="info" @click.stop="hideResetStatusModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import EUpdateStatsModal from './changeStatusModal'
  import ModalCompanyInfo from './modalCompanyInfo'
  import DataUpdate from './dataUpdate'
  import ShowTokenModel from './showTokenModel'
  import PredefinedImageModel from './predefinedImageModel'
  import { statusOfCompany, listingSortWay } from '@/modules/settings/'
  import { contains, equals, path, pathOr } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'ListingList',
    mixins: [mixins.isWriteAvailable],
    components: {
      ModalCompanyInfo,
      DataUpdate,
      ShowTokenModel,
      EUpdateStatsModal,
      PredefinedImageModel
    },
    data () {
      return {
        companyIdToResetStatus: '',
        isResetStatusModalVisible: false,
        statusOfCompany,
        listingSortWay,
        activeStatus: '',
        searchValueCompany: '',
        searchValueName: '',
        searchValueEmail: '',
        isLoading: true,
        isLoadTable: false,
        PDFimage: '',
        token: '',
        pagination: {
          page: 1,
          rowsPerPage: 10
        },
        hasDialogs: {
          openModel: false,
          delete: false,
          remind: false,
          approve: false,
          dataUpdate: false,
          showToken: false,
          PDFimage: false
        },
        modalId: null,
        listingStatus: '',
        listingInvitation: {},
        listingMetadata: {},
        additionalInformation: {},
        dataUpdate: {},
        headers: [
          { text: 'Name', align: 'left', value: 'name', search: true, sortable: true, width: 150 },
          { text: 'Receiver company', align: 'left', value: 'receiverCompany', search: true, sortable: true, width: 250 },
          { text: 'Company', align: 'left', value: 'company', search: true, sortable: true, width: 250 },
          { text: 'Receiver email', value: 'receiverEmail', search: true, sortable: true, width: 350 },
          { text: 'Email', value: 'email', search: true, sortable: true, width: 350 },
          { text: 'Status', value: 'status', search: true, sortable: true, width: 150 },
          { text: 'Update Data', value: 'updateData', search: false, sortable: false, width: 100 },
          { text: 'Token', value: 'token', search: false, sortable: false, align: 'center', width: 80 },
          { text: 'Pre default PDF', value: 'preDefaultPDF', search: false, sortable: false, width: 100 },
          { text: 'Action', search: false, sortable: false, align: 'center', width: 350 }
        ],
        changableId: null,
        buttonDisabled: false,
        scopeForWrite: 'listing:write'
      }
    },
    computed: {
      ...mapGetters([
        'listings',
        'getCounterListing',
        'getFormData',
        'getTotalItemsListings'
      ])
    },
    watch: {
      searchValueEmail () {
        this.getDataFromApi()
      },
      searchValueName () {
        this.getDataFromApi()
      },
      searchValueCompany () {
        this.getDataFromApi()
      },
      pagination: {
        handler (val, oldVal) {
          if (val.totalItems !== oldVal.totalItems) return
          this.getDataFromApi()
        },
        deep: true
      },
      activeStatus (val) {
        if (val) this.getDataFromApi()
      },
      activeCategory (val) {
        if (val) this.getDataFromApi()
      },
      visibilityStatus (val) {
        if (val) this.getDataFromApi()
      }
    },
    methods: {
      contains,
      ...mapActions([
        'fetchListing',
        'fetchCounterListing',
        // 'createListing',
        // 'updateListing',
        'updateApproveListing',
        'remindListing',
        'deleteListing',
        'downloadExcel',
        'showResultErrorMessage',
        'getInterpritationFormData',
        'exportListingPDF',
        'createPreviewListingPDF',
        'resetListingStatus',
        'listingPayloadAction'
      ]),
      sortingDirection (dir) {
        return dir ? 'Desc' : 'Asc'
      },
      sort (str) {
        if (str === 'status') {
          return 'ListingInvitation.Status'
        }
        return this.listingSortWay[str]
      },
      checkWayOfMetadata (obj, way, prop) {
        return pathOr('', ['metadata', way, prop], obj)
      },
      checkWayOfListingInvitation (obj, prop) {
        return pathOr('', ['listingInvitation', prop], obj)
      },
      resetFilterFields () {
        this.searchValueCompany = ''
        this.searchValueName = ''
        this.searchValueEmail = ''
      },
      async reset () {
        this.activeStatus = ''
        this.pagination = {
          page: 1,
          rowsPerPage: 10,
          sortBy: null,
          descending: false
        }
        this.resetFilterFields()
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        this.isLoading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const sorted = !!sortBy ? this.sort(sortBy) : null
        const filterCompany = {
          searchValue: this.searchValueCompany,
          filterBy: this.listingSortWay['company']
        }
        const filterName = {
          searchValue: this.searchValueName,
          filterBy: this.listingSortWay['name']
        }
        const filterEmail= {
          searchValue: this.searchValueEmail,
          filterBy: this.listingSortWay['email']
        }
        const sorter = {
          direction: this.sortingDirection(descending),
          sortBy: sorted
        }
        const equalsStatus = {
          status: this.activeStatus,
          filterBy: this.sort('status')
        }
        const getParams = {
          page: pageCheck,
          itemsOnPage: equals(rowsPerPage, -1) ? this.getTotalItemsListings : rowsPerPage,
          filterCompany,
          filterName,
          filterEmail,
          sorter,
          equalsStatus
        }
        this.listingPayloadAction(getParams)
        try {
          await this.fetchListing(getParams)
          await this.fetchCounterListing()
          this.isLoadTable = true
        } catch (e) {
          console.error(e)
        } finally {
          this.isLoading = false
        }
      },
      doneSaveListing () {
        this.getDataFromApi ()
      },
      // saveListing ([id, newListingInvitation]) {
      //   id
      //     ? this.prepareEditListing(id, newListingInvitation)
      //     : this.prepareCreateListing(newListingInvitation)
      // },
      // prepareCreateListing (newListing) {
      //   const body = { ...newListing }
      //   const invitation = {
      //     name: newListing.listingInvitation.name,
      //     company: newListing.listingInvitation.company,
      //     email: newListing.listingInvitation.email,
      //     status: 'NotYet'
      //   }
      //   this.createListing({ body, invitation})
      // },
      // prepareEditListing (id, editListing) {
      //   const body = { ...editListing }
      //   const listing = { id, body }
      //   this.updateListing([listing])
      // },
      // async approved (blitzId) {
      //   this.buttonDisabled = true
      //   try {
      //     await this.updateApproveListing(blitzId)
      //     await this.getDataFromApi()
      //   } catch (err) {
      //     this.showResultErrorMessage(err.message)
      //   } finally {
      //     this.closeModal('approve')
      //     this.buttonDisabled = false
      //   }
      // },
      // async remind (listingId) {
      //   this.buttonDisabled = true
      //   try {
      //     await  this.remindListing(listingId)
      //     await this.getDataFromApi()
      //   } catch (err) {
      //     this.showResultErrorMessage(err.message)
      //   } finally {
      //     this.closeModal('remind')
      //     this.buttonDisabled = false
      //   }
      // },
      // async deleted (listingId) {
      //   this.buttonDisabled = true
      //   try {
      //     await this.deleteListing(listingId)
      //     await this.getDataFromApi()
      //   } catch (err) {
      //     this.showResultErrorMessage(err.message)
      //   } finally {
      //     this.closeModal('delete')
      //     this.buttonDisabled = false
      //   }
      // },
      openQuestionModal (actionString, id) { // pass one of keys from data's dialog property
        this.hasDialogs[actionString] = true
        this.changableId = id
      },
      openModal (action, editItem) {
        this.hasDialogs.openModel = true
        if (action === 'edit') {
          this.modalId = editItem.id
          this.listingStatus = pathOr('', ['listingInvitation', 'status'], editItem)
          this.listingInvitation = pathOr({}, ['metadata', 'listingInvitation'], editItem)
          this.listingMetadata = pathOr({}, ['metadata', 'listingMetadata'], editItem)
          this.additionalInformation = pathOr({}, ['metadata', 'additionalInformation'], editItem)
        } else {
          this.modalId = null
          this.listingInvitation = {}
          this.listingMetadata = {}
          this.additionalInformation = {}
        }
      },
      openDataUpdate (editItem) {
        this.hasDialogs.dataUpdate = true
        this.dataUpdate = editItem
      },
      openTokenModel (token) {
        this.hasDialogs.showToken = true
          if (process.browser) {
            this.token  = window.encodeURIComponent(token)
          }
      },
      closeModal (typeOfAction) {
        this.hasDialogs[typeOfAction] = false
      },
      async showPDF ({ listingInvitation, metadata }) {
        if (listingInvitation.status === 'Approved' || listingInvitation.status === 'Pending') {
          try {
            //  convert img.png to string it is need to render image at predefinedImageModel component
            const src = Buffer.from(await this.createPreviewListingPDF(metadata), 'binary').toString('base64')
            this.PDFimage = `data:image/png;base64,${src}`
            this.hasDialogs.PDFimage = true
          } catch (err) {
            console.error(err)
          }
        }
      },
     async downloadPDF () {
        this.exportListingPDF()
      },
      showResetStatusModal(id) {
        this.companyIdToResetStatus = id
        this.isResetStatusModalVisible = true
      },
      hideResetStatusModal() {
        this.companyIdToResetStatus = ''
        this.isResetStatusModalVisible = false
      },
      async resetStatus () {
        try {
          await this.resetListingStatus(this.companyIdToResetStatus)
          this.hideResetStatusModal()
        } catch (e) {
          console.error(e)
        }
      }
    },
    mounted () {
      this.getDataFromApi()
      this.getInterpritationFormData('listing_registration')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/index.vue